(() => {
  if (window.__completeLookLoaded) {
    try { console.warn('[CL] Script ya cargado, abortando segunda carga'); } catch (e) {}
    return;
  }
  window.__completeLookLoaded = true;

  var DEBUG = true;
  function log(){ if(!DEBUG) return; try{ console.log.apply(console, ['[CL]'].concat([].slice.call(arguments))); }catch(e){} }
  function warn(){ if(!DEBUG) return; try{ console.warn.apply(console, ['[CL]'].concat([].slice.call(arguments))); }catch(e){} }
  function err(){ if(!DEBUG) return; try{ console.error.apply(console, ['[CL]'].concat([].slice.call(arguments))); }catch(e){} }

  var HTML_EL = document.documentElement;
  var SHOP_LOCALE = HTML_EL.getAttribute('lang') || navigator.language || 'es-ES';
  var SHOP_CURRENCY = HTML_EL.getAttribute('currency') || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var HTML_SYMBOL = HTML_EL.getAttribute('currency-symbol') || '';

  var _moneyFmt;
  function moneyFormatter(){
    if(!_moneyFmt){
      try {
        _moneyFmt = new Intl.NumberFormat(SHOP_LOCALE, { style:'currency', currency:SHOP_CURRENCY, currencyDisplay:'symbol' });
      } catch(e) {
        _moneyFmt = {
          format: function(n){ return (HTML_SYMBOL || '') + n.toFixed(2) },
          formatToParts: function(n){ return [{type:'currency', value: HTML_SYMBOL || ''},{type:'integer', value: String(n.toFixed(2))}] }
        };
      }
    }
    return _moneyFmt;
  }
  function formatMoney(cents){
    var n = Number(cents);
    if (isNaN(n)) return '';
    var partsFn = moneyFormatter().formatToParts || null;
    if (partsFn) {
      var parts = moneyFormatter().formatToParts(n/100);
      var currencyPart = null;
      for (var i=0;i<parts.length;i++){ if(parts[i].type === 'currency'){ currencyPart = parts[i]; break; } }
      var symbol = (currencyPart && currencyPart.value) || HTML_SYMBOL || '';
      var number = '';
      for (var j=0;j<parts.length;j++){ if(parts[j].type !== 'currency'){ number += parts[j].value } }
      return symbol + number + ' ' + SHOP_CURRENCY;
    } else {
      return moneyFormatter().format(n/100) + ' ' + SHOP_CURRENCY;
    }
  }

  /**
   * @param {string|number} variantId
   */
  function cartAdd(variantId) {
    var formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', '1');

    document.querySelectorAll('cart-items-component').forEach(function(el) {
      var htmlEl = /** @type {HTMLElement} */ (el);
      if (htmlEl.dataset.sectionId) formData.append('sections', htmlEl.dataset.sectionId);
    });

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function(r) {
        if (!r.ok) throw new Error('Cart error ' + r.status);
        return r.json();
      })
      .then(function(data) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: data, sourceId: String(variantId), data: { source: 'cart-add-helper', itemCount: 1, sections: data.sections || {} } }
        }));

        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var childTypes = ['badge', 'customization'];
            var itemCount = (cart.items || []).reduce(function(/** @type {number} */ sum, /** @type {any} */ item) {
              return childTypes.includes((item.product_type || '').toLowerCase()) ? sum : sum + item.quantity;
            }, 0);
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart, sourceId: String(variantId), data: { source: 'cart-add-helper', itemCount: itemCount } }
            }));
          })
          .catch(function() {});

        return data;
      });
  }

  function updatePricesForCard(card, variantData){
    if (!card || !variantData) return;
    var currentPriceEls = card.querySelectorAll('.complete-look-card-current-price');
    var comparePriceEls = card.querySelectorAll('.complete-look-card-compare-price');
    if (currentPriceEls.length && variantData.price != null) {
      Array.prototype.forEach.call(currentPriceEls, function(el){ el.textContent = formatMoney(variantData.price) });
    }
    var showCompare = variantData.compare_at_price && Number(variantData.compare_at_price) > Number(variantData.price || 0);
    Array.prototype.forEach.call(comparePriceEls, function(el){
      if (showCompare) { el.textContent = formatMoney(variantData.compare_at_price); el.style.display = '' }
      else { el.style.display = 'none' }
    });
  }

  function showImage(images, index){
    Array.prototype.forEach.call(images, function(img, i){
      if (i === index) img.classList.add('visible');
      else img.classList.remove('visible');
    });
  }

  function initCard(card){
    if (!card || card.dataset.initialized === 'true') return;
    card.dataset.initialized = 'true';

    var images = card.querySelectorAll('.complete-look-card-image');
    var prevBtn = card.querySelector('.complete-look-card-arrow-prev');
    var nextBtn = card.querySelector('.complete-look-card-arrow-next');
    var imgContainer = card.querySelector('.complete-look-card-image-container');

    var sizeSelect = card.querySelector('.complete-look-card-size-select');
    var addToCartBtn = card.querySelector('.complete-look-card-add-to-cart');
    var errorMsg = card.querySelector('.complete-look-card-error');

    var liveRegion = (function(){
      var lr = card.querySelector('[aria-live="polite"]');
      if (lr) return lr;
      lr = document.createElement('div');
      lr.setAttribute('aria-live','polite');
      lr.className = 'sr-only';
      card.appendChild(lr);
      return lr;
    })();

    var addText  = (addToCartBtn && addToCartBtn.getAttribute('data-text-add'))  || 'Add to cart';
    var soldText = (addToCartBtn && addToCartBtn.getAttribute('data-text-sold')) || 'Sold out';
    function setBtnText(txt){
      if (!addToCartBtn) return;
      var span = addToCartBtn.querySelector('span');
      if (span) span.textContent = txt;
    }

    var isSingleVariant = (!sizeSelect) || card.getAttribute('data-variants-count') === '1';

    var selectedVariantId = '';
    var validationErrorVisible = false;

    if (images && images.length) showImage(images, 0);
    if (prevBtn) prevBtn.style.display = 'none';
    if (nextBtn) nextBtn.style.display = 'none';
    if (imgContainer) { try { imgContainer.replaceWith(imgContainer.cloneNode(true)) } catch(e){} }

    var variantMap = {};
    if (sizeSelect) {
      Array.prototype.forEach.call(sizeSelect.options, function(opt){
        var id = opt.value;
        if (!id) return;
        variantMap[id] = {
          price: opt.getAttribute('data-price') ? parseInt(opt.getAttribute('data-price'), 10) : null,
          compare_at_price: opt.getAttribute('data-compare') ? parseInt(opt.getAttribute('data-compare'), 10) : null,
          available: opt.getAttribute('data-available') === 'true'
        };
      });
    }

    if (addToCartBtn) {
      if (sizeSelect) {
        addToCartBtn.removeAttribute('disabled');
        setBtnText(addText);
      } else {
        var defVar = card.getAttribute('data-default-variant-id');
        var defAvailAttr = card.getAttribute('data-default-available');
        var defAvail = (defAvailAttr === 'true' || defAvailAttr === true);
        if (defVar && defAvail) {
          selectedVariantId = defVar;
          addToCartBtn.removeAttribute('disabled');
          setBtnText(addText);
        } else {
          addToCartBtn.setAttribute('disabled', '');
          setBtnText(soldText);
        }
      }
    }

    function showSizeError(){
      if (!sizeSelect) return;
      validationErrorVisible = true;
      sizeSelect.style.outline = '2px solid var(--orange-dark)';
      sizeSelect.setAttribute('aria-invalid', 'true');
      if (errorMsg) errorMsg.hidden = false;
      liveRegion.textContent = 'Por favor, selecciona una talla antes de añadir al carrito.';
      try { sizeSelect.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' }) } catch(e){}
      try { sizeSelect.focus({ preventScroll: true }) } catch(e){}
    }

    function clearSizeError(){
      if (!sizeSelect) return;
      if (!validationErrorVisible) return;
      validationErrorVisible = false;
      sizeSelect.style.outline = '';
      sizeSelect.removeAttribute('aria-invalid', '');
      if (errorMsg) errorMsg.hidden = true;
      liveRegion.textContent = '';
    }

    function onSizeChange(){
      if (!sizeSelect) return;
      selectedVariantId = sizeSelect.value;
      var hasSelection = !!selectedVariantId;
      var opt = sizeSelect.options[sizeSelect.selectedIndex];
      var available = !!(opt && opt.getAttribute('data-available') === 'true');

      if (hasSelection && available) {
        clearSizeError();
        setBtnText(addText);
      } else if (!hasSelection) {
        clearSizeError();
        selectedVariantId = '';
        setBtnText(addText);
      } else {
        setBtnText(soldText);
      }

      if (hasSelection && variantMap[selectedVariantId]) {
        updatePricesForCard(card, variantMap[selectedVariantId]);
      } else {
        var defPrice = parseInt(card.getAttribute('data-default-price'), 10);
        var defCompare = parseInt(card.getAttribute('data-default-compare'), 10);
        if (!isNaN(defPrice)) {
          updatePricesForCard(card, { price: defPrice, compare_at_price: isNaN(defCompare) ? null : defCompare });
        }
      }
    }
    if (sizeSelect) {
      sizeSelect.addEventListener('change', onSizeChange);
      sizeSelect.addEventListener('input', onSizeChange);
    }

    (function(){
      var defPrice = parseInt(card.getAttribute('data-default-price'), 10);
      var defCompare = parseInt(card.getAttribute('data-default-compare'), 10);
      if (!isNaN(defPrice)) {
        updatePricesForCard(card, { price: defPrice, compare_at_price: isNaN(defCompare) ? null : defCompare });
      }
    })();

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function(){
        if (isSingleVariant && !selectedVariantId) selectedVariantId = card.getAttribute('data-default-variant-id');
        if (!selectedVariantId && !isSingleVariant) { showSizeError(); return }
        if (!selectedVariantId && isSingleVariant) {
          addToCartBtn.setAttribute('disabled','');
          setBtnText(soldText);
          return;
        }

        cartAdd(selectedVariantId)
          .then(function(){
            if (isSingleVariant) {
              var defVar = card.getAttribute('data-default-variant-id');
              var defAvail = (card.getAttribute('data-default-available') === 'true');
              selectedVariantId = defAvail ? defVar : '';
              if (defAvail) { addToCartBtn.removeAttribute('disabled'); setBtnText(addText) }
              else { addToCartBtn.setAttribute('disabled',''); setBtnText(soldText) }
            } else {
              if (sizeSelect) sizeSelect.selectedIndex = 0;
              selectedVariantId = '';
              clearSizeError();
              addToCartBtn.removeAttribute('disabled');
              setBtnText(addText);
            }

            var defPrice = parseInt(card.getAttribute('data-default-price'), 10);
            var defCompare = parseInt(card.getAttribute('data-default-compare'), 10);
            if (!isNaN(defPrice)) updatePricesForCard(card, { price: defPrice, compare_at_price: isNaN(defCompare) ? null : defCompare });
          })
          .catch(function(e){ err('add to cart failed', e) });
      });
    }
  }

  function initAll(){
    var cards = document.querySelectorAll('.complete-look-card');
    Array.prototype.forEach.call(cards, initCard);
    initCustomScrollbars();
  }

  function initCustomScrollbars(){
    var grids = document.querySelectorAll('.complete-look-grid');
    Array.prototype.forEach.call(grids, function(grid){
      if (!grid || grid.dataset.scrollbarInitialized === 'true') return;
      grid.dataset.scrollbarInitialized = 'true';

      var bar = document.createElement('div');
      bar.className = 'complete-look-scrollbar';
      var track = document.createElement('div');
      track.className = 'complete-look-scrollbar-track';
      var thumb = document.createElement('div');
      thumb.className = 'complete-look-scrollbar-thumb';
      track.appendChild(thumb);
      bar.appendChild(track);
      grid.parentNode.insertBefore(bar, grid.nextSibling);

      function refresh(){
        var sw = grid.scrollWidth || 0;
        var cw = grid.clientWidth || 0;
        var sl = grid.scrollLeft || 0;

        if (sw <= cw + 1) {
          bar.style.display = 'none';
          return;
        } else {
          bar.style.display = '';
        }

        var trackW = track.clientWidth || 1;
        var thumbW = Math.max(24, Math.round((cw / sw) * trackW)); // mínimo visible 24px
        var maxScroll = sw - cw;
        var maxLeft = trackW - thumbW;
        var left = maxScroll > 0 ? Math.round((sl / maxScroll) * maxLeft) : 0;

        thumb.style.width = thumbW + 'px';
        thumb.style.transform = 'translateX(' + left + 'px)';
      }

      var scheduled = false;
      function onScroll(){
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function(){ scheduled = false; refresh(); });
      }

      function onResize(){
        // esperar a que layout/pintas de imágenes se asienten
        requestAnimationFrame(refresh);
        setTimeout(refresh, 0);
        setTimeout(refresh, 100);
      }

      grid.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize);

      // click en track para saltar
      track.addEventListener('click', function(e){
        var rect = track.getBoundingClientRect();
        var clickX = e.clientX - rect.left;
        var trackW = rect.width;
        var sw = grid.scrollWidth, cw = grid.clientWidth;
        var maxScroll = sw - cw;
        var target = Math.round((clickX / Math.max(1, trackW)) * Math.max(0, maxScroll));
        grid.scrollTo({ left: target, behavior: 'smooth' });
      });

      // drag del thumb (opcional)
      (function enableDrag(){
        var dragging = false;
        var startX = 0;
        var startLeft = 0;

        thumb.addEventListener('mousedown', function(e){
          dragging = true;
          startX = e.clientX;
          var m = window.getComputedStyle(thumb).transform;
          var cur = 0;
          if (m && m !== 'none'){
            var parts = m.match(/matrix\(.*,\s*(-?\d+\.?\d*)\)$/);
            if (parts && parts[1]) cur = parseFloat(parts[1]) || 0;
          }
          startLeft = cur;
          e.preventDefault();
        });
        window.addEventListener('mousemove', function(e){
          if (!dragging) return;
          var dx = e.clientX - startX;
          var trackW = track.clientWidth || 1;
          var sw = grid.scrollWidth, cw = grid.clientWidth;
          var thumbW = thumb.clientWidth || 1;
          var maxLeft = trackW - thumbW;
          var newLeft = Math.max(0, Math.min(maxLeft, startLeft + dx));
          var maxScroll = Math.max(0, sw - cw);
          var target = maxScroll ? (newLeft / maxLeft) * maxScroll : 0;
          grid.scrollLeft = target;
          refresh();
        });
        window.addEventListener('mouseup', function(){ dragging = false; });
        window.addEventListener('blur', function(){ dragging = false; });
      })();

      // inicial
      refresh();
      // por si se cargan imágenes asíncronas
      setTimeout(refresh, 0);
      setTimeout(refresh, 250);
      setTimeout(refresh, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  try {
    var mo = new MutationObserver(function(muts){
      for (var k=0;k<muts.length;k++){
        var m = muts[k];
        if (!m.addedNodes) continue;
        m.addedNodes.forEach(function(node){
          if (!(node instanceof HTMLElement)) return;
          if (node.matches && node.matches('.complete-look-card')) initCard(node);
          if (node.querySelectorAll) {
            var inner = node.querySelectorAll('.complete-look-card');
            if (inner && inner.length) Array.prototype.forEach.call(inner, initCard);
          }
          if (node.matches && node.matches('.complete-look-grid')) {
            // reinit custom scrollbar para nuevos grids
            node.dataset.scrollbarInitialized = '';
            initCustomScrollbars();
          }
        });
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch(e) { warn('MO no disponible', e) }

  window.CompleteLook = window.CompleteLook || {};
  window.CompleteLook.initCards = initAll;
  window.CompleteLook.initCard = initCard;
  window.CompleteLook.__debug = true;
})();
